import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.5798 4.57767L8.68268 3.98457L6.94055 0.28611C6.89297 0.184848 6.81469 0.102875 6.71799 0.0530477C6.47547 -0.0723237 6.18077 0.0321525 6.05951 0.28611L4.31738 3.98457L0.420236 4.57767C0.312792 4.59374 0.214557 4.64679 0.139346 4.72715C0.0484205 4.82502 -0.00168366 4.95668 4.32016e-05 5.09321C0.00177006 5.22974 0.0551867 5.35996 0.148556 5.45527L2.96819 8.33399L2.30204 12.3989C2.28642 12.4935 2.29641 12.5907 2.33088 12.6796C2.36536 12.7686 2.42293 12.8456 2.49708 12.902C2.57123 12.9584 2.65898 12.9919 2.75039 12.9987C2.8418 13.0055 2.9332 12.9854 3.01424 12.9406L6.50003 11.0214L9.98582 12.9406C10.081 12.9936 10.1915 13.0113 10.2974 12.992C10.5645 12.9438 10.7441 12.6786 10.698 12.3989L10.0319 8.33399L12.8515 5.45527C12.9283 5.37651 12.9789 5.27364 12.9943 5.16113C13.0357 4.87985 12.8484 4.61946 12.5798 4.57767Z",
		fill: "#FADB14"
	})]
});
const ForwardRef = forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
